"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSoundEffectRequest = void 0;
var CreateSoundEffectRequest_1 = require("./CreateSoundEffectRequest");
Object.defineProperty(exports, "CreateSoundEffectRequest", { enumerable: true, get: function () { return CreateSoundEffectRequest_1.CreateSoundEffectRequest; } });
